import React, { FC, useId, useState } from 'react';
import { useBrowserScreen } from '@root/hooks/useBrowserScreen';
import useJoiValidation from '@root/hooks/useJoiValidation';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { SintomasSliderProps } from './models';
import { SintomasSliderSchema } from './SintomasSlider.schema';

import './SintomasSlider.scss';

const SintomasSlider: FC<SintomasSliderProps> = ({ items }) => {
  const { data } = useJoiValidation(SintomasSliderSchema, 'SintomasSliderSchema', {
    items,
  });
  const uid = useId();
  const [flipped, setFlipped] = useState<Map<number, boolean>>(new Map());
  const [showHint, setShowHint] = useState<Map<number, boolean>>(new Map());
  const { isMobileView, isTabletView } = useBrowserScreen();
  const isTouchDevice = isMobileView || isTabletView;

  const toggleFlip = (index: number) => {
    setFlipped((prev) => {
      const newFlipped = new Map(prev);
      newFlipped.set(index, !newFlipped.get(index));

      return newFlipped;
    });
    setShowHint((prev) => {
      const newShowHint = new Map(prev);
      newShowHint.set(index, false);

      return newShowHint;
    });
  };

  const handleTap = (index: number) => {
    if (isTouchDevice && !flipped.get(index) && !showHint.get(index)) {
      setShowHint((prev) => {
        const newShowHint = new Map(prev);
        newShowHint.set(index, true);

        return newShowHint;
      });
      setTimeout(() => {
        setShowHint((prev) => {
          const newShowHint = new Map(prev);
          newShowHint.set(index, false);

          return newShowHint;
        });
      }, 3000);

      return;
    }

    toggleFlip(index);
  };

  const handleKeyDown = (event: React.KeyboardEvent, index: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTap(index);
    }
  };

  return (
    <section className="sintomas-slider">
      <Swiper
        modules={[Pagination]}
        pagination={{
          clickable: true,
        }}
        spaceBetween={0}
        slidesPerView="auto"
        centeredSlides
        initialSlide={0}
        className="sintomas-swiper"
        breakpoints={{
          768: {
            spaceBetween: 80,
          },
        }}
      >
        {data.items.map((item, index) => (
          <SwiperSlide key={`slide-${uid}-${item.name}`}>
            <div
              className={`slide-card ${flipped.get(index) ? 'flipped' : ''} ${
                showHint.get(index) ? 'show-hint' : ''
              }`}
              onClick={() => handleTap(index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              role="button"
              tabIndex={0}
              aria-label={`Flip card ${item.name}`}
            >
              <div className="slide-card-main">
                <img src={item.mainImage} alt={item.name} className="main-image" />
              </div>
              <div className="slide-card-flip">
                <img src={item.flipImage} alt={`${item.alt}`} className="flip-image" />
                <ul className="symptomas-list">
                  <li>
                    <strong>Ataque:</strong> {item.ataque}
                  </li>
                  <li>
                    <strong>Molestia:</strong> {item.molestia}
                  </li>
                  <li>
                    <strong>Debilidad:</strong> {item.debilidad}
                  </li>
                </ul>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default SintomasSlider;
